export default {
  label: 'Czat z naszym zespołem',
  label_unread: 'Czat z naszym zespołem, nowe: {{count}}',
};
